// Racine de la boutique avec le préfixe du marché (ex. /es-mx/), pour garder la bonne devise.
const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/**
 * Advertorial offer : sélecteur de paliers (quantités d'un même produit) +
 * bouton "commander" qui construit le panier et redirige direct sur /checkout.
 * La remise automatique Shopify s'applique seule au checkout.
 */
class AdvertorialOffer extends HTMLElement {
  connectedCallback() {
    this.buy = this.querySelector('[data-ref="buy"]');
    this.tiers = [...this.querySelectorAll('[data-ref="tier"]')];
    this.buy?.addEventListener('click', this.#checkout);
    this.tiers.forEach((t) => t.addEventListener('change', this.#syncSelected));
    this.#syncSelected();
  }

  disconnectedCallback() {
    this.buy?.removeEventListener('click', this.#checkout);
    this.tiers.forEach((t) => t.removeEventListener('change', this.#syncSelected));
  }

  #syncSelected = () => {
    this.querySelectorAll('.advertorial-tier').forEach((label) => {
      const input = label.querySelector('[data-ref="tier"]');
      label.classList.toggle('is-selected', !!input?.checked);
    });
  };

  #checkout = async () => {
    const selected = this.tiers.find((t) => t.checked) || this.tiers[0];
    const quantity = selected ? parseInt(selected.value, 10) : 1;
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    this.buy.setAttribute('disabled', '');
    this.buy.classList.add('loading');

    try {
      if (this.dataset.clearCart === 'true') {
        await fetch(`${shopRoot}cart/clear.js`, { method: 'POST' });
      }
      await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
      });
      window.location.href = `${shopRoot}checkout`;
    } catch (error) {
      this.buy.removeAttribute('disabled');
      this.buy.classList.remove('loading');
    }
  };
}

if (!customElements.get('advertorial-offer')) {
  customElements.define('advertorial-offer', AdvertorialOffer);
}
